import { CommonModule } from '@angular/common';
import { EventEmitter, Injector, TemplateRef, computed, inject, input, signal } from '@angular/core';
import { FormSubmitButtonDirective } from '@common/forms/frontend-shared';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { UiMenuComponent } from '@common/ui/frontend-shared/menu';
import { ModelActionService } from '@core/frontend-shared';
import { NgLetDirective, takeWhileAlive } from '@core/frontend-shared/utils';
import { CRUD_ITEM_VIEW_SERVICE_TOKEN } from './token';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
const _c0 = [[["", 8, "buttonbar-right"]]];
const _c1 = [".buttonbar-right"];
function CrudItemToolbarComponent_ng_template_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "button", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formSubmitButton", ctx_r0.formService());
  }
}
function CrudItemToolbarComponent_ng_template_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function CrudItemToolbarComponent_ng_template_1_Conditional_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onClickCloseEditor());
    });
    i0.ɵɵelementEnd();
  }
}
function CrudItemToolbarComponent_ng_template_1_Conditional_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CrudItemToolbarComponent_ng_template_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CrudItemToolbarComponent_ng_template_1_Conditional_3_ng_container_0_Template, 1, 0, "ng-container", 9);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.templateLeft);
  }
}
function CrudItemToolbarComponent_ng_template_1_Conditional_7_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CrudItemToolbarComponent_ng_template_1_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CrudItemToolbarComponent_ng_template_1_Conditional_7_ng_container_0_Template, 1, 0, "ng-container", 9);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.templateRight);
  }
}
function CrudItemToolbarComponent_ng_template_1_ng_template_8_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function CrudItemToolbarComponent_ng_template_1_ng_template_8_Conditional_0_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const menu_r4 = i0.ɵɵreference(2);
      return i0.ɵɵresetView(menu_r4.toggle($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(1, "ui-menu", 11, 0);
  }
  if (rf & 2) {
    const actions_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("label", "Aktionen...");
    i0.ɵɵadvance();
    i0.ɵɵproperty("popup", true)("model", actions_r5);
  }
}
function CrudItemToolbarComponent_ng_template_1_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, CrudItemToolbarComponent_ng_template_1_ng_template_8_Conditional_0_Template, 3, 3);
  }
  if (rf & 2) {
    const actions_r5 = ctx.$implicit;
    i0.ɵɵconditional(actions_r5.length ? 0 : -1);
  }
}
function CrudItemToolbarComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵconditionalCreate(1, CrudItemToolbarComponent_ng_template_1_Conditional_1_Template, 1, 1, "button", 4);
    i0.ɵɵconditionalCreate(2, CrudItemToolbarComponent_ng_template_1_Conditional_2_Template, 1, 0, "button", 5);
    i0.ɵɵconditionalCreate(3, CrudItemToolbarComponent_ng_template_1_Conditional_3_Template, 1, 1, "ng-container");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "div", 6);
    i0.ɵɵelementStart(5, "div", 7);
    i0.ɵɵprojection(6);
    i0.ɵɵconditionalCreate(7, CrudItemToolbarComponent_ng_template_1_Conditional_7_Template, 1, 1, "ng-container");
    i0.ɵɵtemplate(8, CrudItemToolbarComponent_ng_template_1_ng_template_8_Template, 1, 1, "ng-template", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const c_r6 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(c_r6.showSaveButton && ctx_r0.formService() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(c_r6.showBackButton ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.templateLeft ? 3 : -1);
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(ctx_r0.templateRight ? 7 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngLet", ctx_r0.contextMenuActions());
  }
}
export let CrudItemToolbarComponent = /*#__PURE__*/(() => {
  class CrudItemToolbarComponent {
    constructor(crudItemViewService) {
      this.crudItemViewService = crudItemViewService;
      this.closeEditor = new EventEmitter();
      this.configInput = input({}, {
        ...(ngDevMode ? {
          debugName: "configInput"
        } : /* istanbul ignore next */{}),
        alias: 'config'
      });
      this.config = computed(() => {
        return {
          showSaveButton: true,
          showBackButton: true,
          showActionsButton: true,
          ...this.configInput()
        };
      }, ...(ngDevMode ? [{
        debugName: "config"
      }] : /* istanbul ignore next */[]));
      this.item = input(...(ngDevMode ? [undefined, {
        debugName: "item"
      }] : /* istanbul ignore next */[]));
      this.formService = input(...(ngDevMode ? [undefined, {
        debugName: "formService"
      }] : /* istanbul ignore next */[]));
      this.actions = signal([], ...(ngDevMode ? [{
        debugName: "actions"
      }] : /* istanbul ignore next */[]));
      this.actionsService = inject(ModelActionService);
      this.injector = inject(Injector);
      this.contextMenuActions = computed(() => {
        const item = this.item();
        const actions = this.actions();
        if (!actions?.length) return [];
        if (!this.config().showActionsButton) return [];
        if (!item) return [];
        return this.actionsService.createMenuItemsFromItemModelActions(actions, () => item, this.injector);
      }, ...(ngDevMode ? [{
        debugName: "contextMenuActions"
      }] : /* istanbul ignore next */[]));
      if (crudItemViewService) crudItemViewService.getItemActions$().pipe(takeWhileAlive()).subscribe(actions => this.actions.set(actions));
    }
    onClickCloseEditor() {
      if (this.crudItemViewService) {
        this.crudItemViewService.navigateTo('list');
      } else {
        this.closeEditor.emit(true);
      }
    }
    static {
      this.ɵfac = function CrudItemToolbarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CrudItemToolbarComponent)(i0.ɵɵdirectiveInject(CRUD_ITEM_VIEW_SERVICE_TOKEN, 8));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: CrudItemToolbarComponent,
        selectors: [["crud-item-toolbar"]],
        inputs: {
          templateLeft: "templateLeft",
          templateRight: "templateRight",
          configInput: [1, "config", "configInput"],
          item: [1, "item"],
          formService: [1, "formService"]
        },
        outputs: {
          closeEditor: "closeEditor"
        },
        ngContentSelectors: _c1,
        decls: 2,
        vars: 1,
        consts: [["menu", ""], [1, "toolbar"], [3, "ngLet"], [1, "left"], ["e2e-crud-editor-submit-button", "", "type", "submit", "uiButton", "", 3, "formSubmitButton"], ["e2e-crud-editor-back-button", "", "uiButton", "", "icon", "times", "label", "Zur\u00FCck zur \u00DCbersicht", 1, "ui-button-grey"], [1, "center"], [1, "right"], ["e2e-crud-editor-back-button", "", "uiButton", "", "icon", "times", "label", "Zur\u00FCck zur \u00DCbersicht", 1, "ui-button-grey", 3, "click"], [4, "ngTemplateOutlet"], ["uiButton", "", "icon", "bars", 1, "ui-button-grey", 3, "click", "label"], ["appendTo", "body", 3, "popup", "model"]],
        template: function CrudItemToolbarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c0);
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, CrudItemToolbarComponent_ng_template_1_Template, 9, 5, "ng-template", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngLet", ctx.config());
          }
        },
        dependencies: [CommonModule, i1.NgTemplateOutlet, UiButtonComponent, UiMenuComponent, FormSubmitButtonDirective, NgLetDirective],
        styles: [".toolbar[_ngcontent-%COMP%]{display:flex}\n\n/*# sourceMappingURL=crud-item-toolbar.component.ts-angular-inline--26.css.map*/", ".toolbar[_ngcontent-%COMP%] > .center[_ngcontent-%COMP%]{flex:1}\n\n/*# sourceMappingURL=crud-item-toolbar.component.ts-angular-inline--27.css.map*/", ".toolbar[_ngcontent-%COMP%] >*:not(:first-child){margin-left:10px}\n\n/*# sourceMappingURL=crud-item-toolbar.component.ts-angular-inline--29.css.map*/"]
      });
    }
  }
  return CrudItemToolbarComponent;
})();